// extracted by mini-css-extract-plugin
export default {"box":"index_box__udvD0","or":"index_or__Yr60N","forget":"index_forget__EWQse","loginButton":"index_loginButton__14TVO"};